import React from "react";

/**
 * The "small potatoes" wordmark + gradient icon used across every nav bar
 * (landing page, member area, and the shared site header) so they all share
 * one visual identity instead of some using the CDN logo image and others
 * this inline mark.
 */
const BrandMark = ({ onClick, size = 34, fontSize = 19 }) => (
  <a
    href="#"
    style={{
      display: "flex",
      alignItems: "center",
      gap: 10,
      textDecoration: "none",
      color: "inherit",
      cursor: "pointer",
    }}
    onClick={(e) => {
      e.preventDefault();
      onClick && onClick(e);
    }}
  >
    <svg width={size} height={size} viewBox="0 0 34 34" fill="none">
      <defs>
        <linearGradient id="spMark" x1="0" y1="0" x2="34" y2="34">
          <stop offset="0" stopColor="var(--color-accent)" />
          <stop offset="1" stopColor="var(--color-accent-2)" />
        </linearGradient>
      </defs>
      <path
        d="M24 6c-6 0-9 3-9 7.5S18 20 21 20c3.5 0 5 1.6 5 3.8C26 27 22.5 28 19 28c-4 0-7.5-1.4-9.5-4"
        stroke="url(#spMark)"
        strokeWidth="4.5"
        strokeLinecap="round"
        fill="none"
      />
    </svg>
    <span className="sp-nav-link sp-brand-text" style={{ fontFamily: "var(--font-heading)", fontSize }}>
      small potatoes
    </span>
  </a>
);

export default BrandMark;
